// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.renewal.LeaseRenewalWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseRenewalWebApiHandler_canTenantAskForRenewal,
  LeaseRenewalWebApiHandler_canTenantAskForRenewal_Path,
  LeaseRenewalWebApiHandler_create,
  LeaseRenewalWebApiHandler_getLeaseExtension,
  LeaseRenewalWebApiHandler_getLeaseExtension_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  CanTenantAskForLeaseRenewalWebApiResponseDto,
  CreateLeaseRenewalWebApiRequestDto,
  CreateLeaseRenewalWebApiResponseDto,
  GetLeaseExtensionWebApiResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface CanTenantAskForRenewalParams {
  leaseId: number;
}
interface GetLeaseExtensionParams {
  leaseExtensionId: number;
}

export type LeaseRenewalWebApiHandler_canTenantAskForRenewal_Options = UseQueryOptions<
  CanTenantAskForLeaseRenewalWebApiResponseDto,
  unknown,
  CanTenantAskForLeaseRenewalWebApiResponseDto,
  readonly [string, CanTenantAskForRenewalParams]
>;

const LeaseRenewalWebApiHandler_canTenantAskForRenewal_GetKey = (getParams: CanTenantAskForRenewalParams) =>
  [LeaseRenewalWebApiHandler_canTenantAskForRenewal_Path, getParams] as const;

export const LeaseRenewalWebApiHandler_canTenantAskForRenewal_queryOptions = (
  getParams: CanTenantAskForRenewalParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeaseRenewalWebApiHandler_canTenantAskForRenewal_GetKey(getParams),
    queryFn: () => LeaseRenewalWebApiHandler_canTenantAskForRenewal(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * is the current tenant and leaseId applicable for a renewal
 */
export const useLeaseRenewalWebApiHandler_canTenantAskForRenewal = (
  getParams: CanTenantAskForRenewalParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseRenewalWebApiHandler_canTenantAskForRenewal_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeaseRenewalWebApiHandler_canTenantAskForRenewal_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeaseRenewalWebApiHandler_canTenantAskForRenewal.getKey = LeaseRenewalWebApiHandler_canTenantAskForRenewal_GetKey;

export interface LeaseRenewalWebApiHandler_create_Args {
  postData: CreateLeaseRenewalWebApiRequestDto;
}

export type LeaseRenewalWebApiHandler_create_Options = UseMutationOptions<
  CreateLeaseRenewalWebApiResponseDto,
  unknown,
  LeaseRenewalWebApiHandler_create_Args
>;

/**
 * create new lease renewal
 */
export const useLeaseRenewalWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<LeaseRenewalWebApiHandler_create_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseRenewalWebApiHandler_create_Args) =>
      LeaseRenewalWebApiHandler_create(args.postData, httpClient),
  });
};

export type LeaseRenewalWebApiHandler_getLeaseExtension_Options = UseQueryOptions<
  GetLeaseExtensionWebApiResponseDto,
  unknown,
  GetLeaseExtensionWebApiResponseDto,
  readonly [string, GetLeaseExtensionParams]
>;

const LeaseRenewalWebApiHandler_getLeaseExtension_GetKey = (getParams: GetLeaseExtensionParams) =>
  [LeaseRenewalWebApiHandler_getLeaseExtension_Path, getParams] as const;

export const LeaseRenewalWebApiHandler_getLeaseExtension_queryOptions = (
  getParams: GetLeaseExtensionParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeaseRenewalWebApiHandler_getLeaseExtension_GetKey(getParams),
    queryFn: () => LeaseRenewalWebApiHandler_getLeaseExtension(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get lease extension
 */
export const useLeaseRenewalWebApiHandler_getLeaseExtension = (
  getParams: GetLeaseExtensionParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseRenewalWebApiHandler_getLeaseExtension_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeaseRenewalWebApiHandler_getLeaseExtension_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeaseRenewalWebApiHandler_getLeaseExtension.getKey = LeaseRenewalWebApiHandler_getLeaseExtension_GetKey;
